function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".highlight_svg__cls-1{fill:#63c}.highlight_svg__cls-2,.highlight_svg__cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round}.highlight_svg__cls-2{stroke:#63c;stroke-width:4px}.highlight_svg__cls-3{stroke:#ccc0fd;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "highlight_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "highlight_svg__cls-2",
  d: "M94 48c0 25.19-20.29 45.74-45.53 46-25.4.26-46.21-20.13-46.46-45.53C1.75 23.06 22.13 2.26 47.53 2c12.7-.13 24.25 4.9 32.66 13.14"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight_svg__cls-3",
  d: "M81 48c0 18.07-14.55 32.81-32.67 33-18.22.18-33.15-14.44-33.33-32.66-.18-18.22 14.44-33.15 32.66-33.33 9.11-.09 17.4 3.52 23.43 9.43"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight_svg__cls-3",
  d: "M68 48c0 10.95-8.82 19.89-19.8 20-11.05.11-20.09-8.75-20.2-19.8-.11-11.05 8.75-20.09 19.8-20.2 5.52-.06 10.54 2.13 14.2 5.71"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight_svg__cls-2",
  d: "M48 48l32.51-32.51"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 7.5,
  fill: "#00ffcb",
  stroke: "#63c",
  strokeWidth: 4,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  className: "highlight_svg__cls-1",
  cx: 15,
  cy: 48,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "highlight_svg__cls-1",
  cx: 71.33,
  cy: 71.33,
  r: 5
}));

function SvgHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "highlight_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgOTYgOTYiPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTF7ZmlsbDojNjNjO30uY2xzLTIsLmNscy0ze2ZpbGw6bm9uZTtzdHJva2UtbGluZWNhcDpyb3VuZDt9LmNscy0yLC5jbHMtMywuY2xzLTR7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30uY2xzLTIsLmNscy00e3N0cm9rZTojNjNjO3N0cm9rZS13aWR0aDo0cHg7fS5jbHMtM3tzdHJva2U6I2NjYzBmZDtzdHJva2Utd2lkdGg6MnB4O30uY2xzLTR7ZmlsbDojMDBmZmNiO308L3N0eWxlPgogICAgPC9kZWZzPgogICAgPGcgaWQ9IkxheWVyXzEtMiI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMiIKICAgICAgICAgICAgICAgIGQ9Ik05NCw0OGMwLDI1LjE5LTIwLjI5LDQ1Ljc0LTQ1LjUzLDQ2LTI1LjQsLjI2LTQ2LjIxLTIwLjEzLTQ2LjQ2LTQ1LjUzQzEuNzUsMjMuMDYsMjIuMTMsMi4yNiw0Ny41MywyYzEyLjctLjEzLDI0LjI1LDQuOSwzMi42NiwxMy4xNCIgLz4KICAgICAgICAgICAgPHBhdGggY2xhc3M9ImNscy0zIgogICAgICAgICAgICAgICAgZD0iTTgxLDQ4YzAsMTguMDctMTQuNTUsMzIuODEtMzIuNjcsMzMtMTguMjIsLjE4LTMzLjE1LTE0LjQ0LTMzLjMzLTMyLjY2LS4xOC0xOC4yMiwxNC40NC0zMy4xNSwzMi42Ni0zMy4zMyw5LjExLS4wOSwxNy40LDMuNTIsMjMuNDMsOS40MyIgLz4KICAgICAgICAgICAgPHBhdGggY2xhc3M9ImNscy0zIgogICAgICAgICAgICAgICAgZD0iTTY4LDQ4YzAsMTAuOTUtOC44MiwxOS44OS0xOS44LDIwLTExLjA1LC4xMS0yMC4wOS04Ljc1LTIwLjItMTkuOC0uMTEtMTEuMDUsOC43NS0yMC4wOSwxOS44LTIwLjIsNS41Mi0uMDYsMTAuNTQsMi4xMywxNC4yLDUuNzEiIC8+CiAgICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjQ4IiB5MT0iNDgiIHgyPSI4MC41MSIgeTI9IjE1LjQ5IiAvPgogICAgICAgICAgICA8Y2lyY2xlIGNsYXNzPSJjbHMtNCIgY3g9IjQ4IiBjeT0iNDgiIHI9IjcuNSIgLz4KICAgICAgICAgICAgPGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIxNSIgY3k9IjQ4IiByPSI1IiAvPgogICAgICAgICAgICA8Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjcxLjMzIiBjeT0iNzEuMzMiIHI9IjUiIC8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgHighlight as ReactComponent };